document.addEventListener("DOMContentLoaded", function () {
  if (window.Sqrl) {
    Sqrl.filters.define("contains", function (val, search) {
      if (val === null || val === undefined) {
        return false;
      }
      if (typeof val === "string" || val instanceof String) {
        return val.indexOf(search) > -1;
      }
      if (Array.isArray(val)) {
        return val.indexOf(search) > -1;
      }
      return false;
    });
  }
});
